import moment from "moment";
import { useState } from "react";
import { useStep } from "react-hooks-helper";
import { useAppSelector } from "../../../../redux/store";
import { useProjetFromLocation } from "../../../../utils/api/launchCampagn/projet.api";
import {
  PAYMENT_TYPE,
  Projet,
} from "../../../../utils/api/launchCampagn/projet.type";
import {
  CARTE_BANCAIRE,
  getPaydunyaCountry,
  PAYDUNYA_COUNTRIES,
  PaydunyaCountry,
} from "../../../../utils/paydunya";
import { COLORS } from "../../../../utils/constants";
import { formatMontant, getImage } from "../../../../utils/utils";
import ConfirmationInvestModal from "../../../modales/ConfirmationInvestModal";
import InvestissementModal from "../../../modales/InvestissementModal";
import FrontFooter from "../../../shared/FrontFooter/FrontFooter";
import FrontHeader from "../../../shared/FrontHeader/FrontHeader";
import { SEO } from "../../../shared/SEO";
import { ShareModal } from "../../Modals/SharePoints/SharePointModal";
import { PartageProjetEncart } from "../../TableauDeBord/mesprojets/PartageProjet";
import { LikeButton } from "../../home/ProjectsList";
import "./CampagneDetails.css";
import Commentaire from "./stepComponents/Commentaire";
import Faq from "./stepComponents/Faq";
import Presentation from "./stepComponents/Presentation";
const steps: any = [
  { id: "presentation", Component: Presentation },
  { id: "commentaire", Component: Commentaire },
  { id: "faq", Component: Faq },
];

function CampainsDetails() {
  const modalId = "CampainsDetailsModal";

  const [item, isLoading] = useProjetFromLocation();

  const {
    navigation: { go },
    index,
  } = useStep({ initialStep: 0, steps });
  const { user } = useAppSelector((s) => s.user);
  const isAdmin = user?.user_type === "admin";
  const [countryCode, setCountryCode] = useState("");
  // Visibilite changee depuis l'encadre de partage : la page l'affiche tout
  // de suite, sans attendre un rechargement.
  const [visibiliteLocale, setVisibiliteLocale] = useState<"public" | "prive">();
  const country = getPaydunyaCountry(countryCode);

  if (!item) return null;

  // Seul un projet valide par l'admin recoit de l'argent ; le serveur le
  // refuse de toute facon, on l'annonce plutot que de laisser echouer.
  const ouvert = item.statut === "online";
  const visibilite = visibiliteLocale ?? item.visibilite;
  const idPorteur =
    typeof item.user === "object" ? (item.user as any)?.id : (item.user as any);
  // L'encadre de partage n'est montre qu'au porteur, sur sa propre page.
  const estPorteur = !!user?.id && idPorteur === user.id;

  return (
    <>
      <SEO title={item.name} />
      <div className="campagne-page-container">
        <div>
          <ConfirmationInvestModal modalId={modalId} />
          <FrontHeader />
        </div>
        <div className="campagne-page-content container-maajjal">
          {estPorteur && (
            <PartageProjetEncart projet={item} onVisibilite={setVisibiliteLocale} />
          )}
          <div className="row">
            <div className="col-md-7">
              <img
                src={getImage(item.photo)}
                className="card-img-detail-campagne"
                alt="img campagne"
              />
            </div>
            <div className="col-md-5">
              <div className="card custom-card-detail-campagne">
                <div className="card-body">
                  <h5 className="card-title card-details-campagne-title mb-4">
                    {item.name}
                    {visibilite === "prive" && (
                      <span
                        className="ms-2 align-middle"
                        title="Ce projet n'apparaît pas sur la plateforme : il n'est accessible que par son lien."
                        style={{
                          fontSize: 12,
                          fontWeight: 500,
                          padding: "3px 10px",
                          borderRadius: 20,
                          background: "rgba(2,24,73,0.08)",
                          color: COLORS.blue,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Projet privé
                      </span>
                    )}
                  </h5>
                  <div className="card-campagne-progresse-container">
                    <div className="card-campagne-progresse-price-container mb-2">
                      <div className="card-detail-campagne-progresse-percentage">
                        ({`${Math.ceil(item.pourcentage)}%`})
                      </div>
                      <div
                        className="card-detail-campagne-progresse-price"
                        style={{ display: "inherit" }}
                      >
                        <span style={{ fontSize: 13 }}>
                          {formatMontant(item?.funds)} (collectés)
                        </span>

                        <span style={{ fontSize: 10, marginLeft: 20 }}>
                          {item.montant_total_debit > 0 &&
                            `${formatMontant(
                              item?.montant_total_debit
                            )} (débités)`}
                        </span>
                      </div>
                    </div>
                    <div
                      className="progress mb-3"
                      style={{
                        height: "10px",
                      }}
                    >
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width: `${Math.ceil(item.pourcentage)}%`,
                          backgroundColor: "#0FBF56",
                        }}
                        aria-valuenow={25}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      ></div>
                    </div>
                    <div className="card-detail-campagne-progresse-details mb-4">
                      <p className="card-detail-campagne-progresse-details-para">
                        sur un objectif de {formatMontant(item?.objectif_levee)}
                      </p>
                    </div>
                  </div>
                  <div className="card-campagne-button-share-container mb-4">
                    <div className="card-detail-campagne-date-lancement">
                      {`Lancé ${moment(item?.date_debut).fromNow()}`}
                    </div>
                  </div>
                  {isAdmin ? null : !ouvert ? (
                    <div className="alert alert-warning" style={{ fontSize: 14 }}>
                      {item.statut === "termine"
                        ? "Cette campagne est terminée : elle n'accepte plus de contributions. Merci à tous ceux qui l'ont soutenue."
                        : "Ce projet n'est pas encore ouvert aux contributions : il est en attente de validation par l'équipe Maajjal. Revenez bientôt sur cette page."}
                    </div>
                  ) : (
                    <div className="">
                      <small>Veuillez choisir un mode de paiement</small>
                      <div className="p-4">
                        <div className="row">
                          <CardWarrapper type={CARTE_BANCAIRE.slug} item={item}>
                            <div className="fa-radio">
                              <div className="item">
                                <div style={{ textAlign: "center" }}>
                                  <img
                                    src={CARTE_BANCAIRE.logo}
                                    style={{ marginTop: 0 }}
                                    className="card-img-financer-campagne text-center"
                                    alt={CARTE_BANCAIRE.label}
                                  />
                                  <div className="card-container-financer-campagne-cb-text">
                                    {CARTE_BANCAIRE.label}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </CardWarrapper>

                          {PAYDUNYA_COUNTRIES.map((c) => (
                            <CountryWarrapper
                              key={c.code}
                              country={c}
                              active={countryCode === c.code}
                              onSelect={() =>
                                setCountryCode(
                                  countryCode === c.code ? "" : c.code
                                )
                              }
                            />
                          ))}
                        </div>

                        {country && (
                          <div className="row mt-3">
                            <div className="col-12">
                              <small>
                                {`Moyens de paiement disponibles — ${country.name}`}
                              </small>
                            </div>
                            {country.channels.map((channel) => (
                              <CardWarrapper
                                key={channel.slug}
                                type={channel.slug}
                                item={item}
                                country={country.code}
                              >
                                <div className="fa-radio">
                                  <div className="item">
                                    <div style={{ textAlign: "center" }}>
                                      {channel.logo && (
                                        <img
                                          src={channel.logo}
                                          className="card-img-paydunya-channel"
                                          alt={channel.label}
                                        />
                                      )}
                                      <div className="card-container-financer-campagne-cb-text">
                                        {channel.label}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </CardWarrapper>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <hr />
          <section className="presentation-projet">
            <div className="row">
              <div className="col-md-7">
                <div className="campagne-stepper-buttons-container mb-4">
                  <button
                    onClick={() => go?.(0)}
                    className={`stepper-mission ${
                      index === 0 && "stepper-active-mission"
                    }`}
                  >
                    Presentation
                  </button>
                  <button
                    onClick={() => go?.(1)}
                    className={`stepper-mission ${
                      index === 1 && "stepper-active-mission"
                    }`}
                  >
                    Commentaire
                  </button>
                  <button
                    onClick={() => go?.(2)}
                    className={`stepper-mission ${
                      index === 2 && "stepper-active-mission"
                    }`}
                  >
                    Faq
                  </button>
                </div>
                {index === 0 && <Presentation item={item} />}
                {index === 1 && <Commentaire projet={item} />}
                {index === 2 && <Faq projet={item} />}
              </div>
              <div className="col-md-5">
                <p className="campagne-detail-projet-para-aside">
                  Partager et aimer pour l’avancement du projet{" "}
                </p>
                <div className="card-campagne-button-share-like">
                  <LikeButton
                    item={item}
                    modalShareId={"ShareModal" + item.id}
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
        <FrontFooter />
        <ShareModal item={item} modalId={"ShareModal" + item.id} />
      </div>
    </>
  );
}

export default CampainsDetails;

// Tuile pays : meme habillage que les tuiles de paiement, mais elle ne declenche
// pas de modale — elle filtre les operateurs affiches. Le drapeau reutilise le
// sprite de react-phone-input-2, deja charge par le champ telephone, d'ou le
// conteneur .react-tel-input sous lequel ses classes pays sont definies.
function CountryWarrapper({
  country,
  active,
  onSelect,
}: {
  country: PaydunyaCountry;
  active: boolean;
  onSelect: () => void;
}) {
  return (
    <div
      className="col-md-3 col-6 mb-2"
      style={{ cursor: "pointer" }}
      onClick={onSelect}
    >
      <div className="fa-radio">
        <div
          className="item"
          style={active ? { boxShadow: `0 0 0 2px ${COLORS.green}` } : undefined}
        >
          <div style={{ textAlign: "center" }}>
            <div className="react-tel-input d-inline-block">
              <div className={`flag ${country.code.toLowerCase()}`} />
            </div>
            <div className="card-container-financer-campagne-cb-text">
              {country.name}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function CardWarrapper({
  type,
  item,
  country,
  children,
}: {
  type: PAYMENT_TYPE;
  item: Projet;
  country?: string;
  children?: any;
}) {
  const modalId = `${type}-${item.id}`;
  return (
    <>
      <InvestissementModal
        type={type}
        modalId={modalId}
        projet={item}
        country={country}
      />
      <div
        data-bs-target={`#${modalId}`}
        data-bs-toggle="modal"
        style={{ cursor: "pointer" }}
        className="col-md-3 col-6 mb-2"
      >
        {children}
      </div>
    </>
  );
}
